export default __webpack_public_path__ + "c6dc58571fca2666de6ded2d07e210e9.png";